<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <button class="btn-back" type="button" @click="voltar">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                                        </svg>
                                        Voltar
                                    </button>
                                    <h1 class="modern-title">
                                        Resultados para “{{ busca }}”
                                    </h1>
                                    <p class="modern-subtitle" v-if="qtdPeriodicos > 0">
                                        {{ qtdPeriodicos }} {{ qtdPeriodicos !== 1 ? 'edições encontradas' : 'edição encontrada' }} na base de periódicos
                                    </p>
                                    <p class="modern-subtitle" v-else-if="busca">
                                        Nenhum resultado encontrado para este termo
                                    </p>
                                    <p class="modern-subtitle" v-else>
                                        Pesquise artigos, edições ou temas nos periódicos.
                                    </p>
                                </div>
                                <div class="header-actions" v-if="user">
                                    <div class="search-box">
                                        <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                        </svg>
                                        <input type="text"
                                               class="modern-search-input"
                                               placeholder="Pesquisar artigos, edições ou temas..."
                                               aria-label="Pesquisar periódicos"
                                               v-model="pesquisa"
                                               @keyup.enter="pesquisar" />
                                        <button class="modern-btn modern-btn-primary" type="button" @click="pesquisar">
                                            Buscar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="pesquisa-periodicos-content">
                        <main>
                            <div class="empty-state" v-if="lstPeriodicos.length === 0 && busca">
                                <p class="empty-title">Nenhum resultado encontrado</p>
                                <p class="empty-sub">Tente outros termos ou verifique a ortografia.</p>
                            </div>

                            <template v-if="lstPeriodicos.length > 0">
                                <div class="results-header">
                                    <div class="section-label">
                                        <span>Edições encontradas</span>
                                    </div>
                                </div>

                                <div class="results-grid">
                                    <BoxPeriodicoPesquisa v-for="(item, index) in lstPeriodicos"
                                                          :key="index"
                                                          :periodico="item" />
                                </div>

                                <div class="load-more" v-if="!totalRecords">
                                    <button class="load-more__btn" @click="carregaPesquisa">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 5v14M5 12l7 7 7-7" /></svg>
                                        Carregar mais resultados
                                    </button>
                                </div>
                            </template>
                        </main>
                    </div>
                </div>
            </div>
        </div>
        <Modais></Modais>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import BoxPeriodicoPesquisa from '@/components/Ferramentas/Periodicos/BoxPeriodicoPesquisa'
    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'Pesquisa',
        components: { Header, Modais, BoxPeriodicoPesquisa },
        props: ['termo'],
        computed: {
            user() { return this.$store.state.user },
        },
        data() {
            return {
                busca: null,
                pesquisa: '',
                lstPeriodicos: [],
                totalRecords: false,
                qtdPeriodicos: 0,
                take: 8,
                skip: 0,
            }
        },
        methods: {
            voltar() {
                this.$router.push({ name: 'Periodicos' })
            },

            pesquisar() {
                if (this.pesquisa && this.pesquisa.trim() !== '') {
                    this.$route.params.termo = this.pesquisa
                    this.busca = this.pesquisa
                    this.load()
                }
            },

            load() {
                this.lstPeriodicos = []
                this.skip = 0
                this.totalRecords = false
                this.qtdPeriodicos = 0
                if (this.busca) this.carregaPesquisa()
            },

            carregaPesquisa() {
                const $this = this
                axios.get(`${urlApi}/Periodico/ResultadosPesquisa`, {
                    params: { dsTermo: $this.busca, take: $this.take, index: $this.skip }
                })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                $this.qtdPeriodicos = res.data.data.qtdRecords
                                if (res.data.data.qtdRecords <= ($this.take * ($this.skip === 0 ? 1 : $this.skip))) {
                                    $this.totalRecords = true
                                }
                                $this.skip = $this.skip++
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    $this.lstPeriodicos.push(res.data.data.rows[i])
                                }
                            }
                        } else {
                            avisoErro('Não foi possível carregar a pesquisa')
                        }
                    })
                    .catch(() => avisoErro('Não foi possível carregar a pesquisa'))
            },
        },
        created() {
            this.busca = this.termo
            this.pesquisa = this.termo
            this.load()
        },
    }
</script>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;0,900;1,400&family=DM+Sans:wght@300;400;500;600&family=Merriweather:ital,wght@0,900;1,400&display=swap');

    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        padding: 2px 0;
    }

    .title-section {
        flex: 1 1 280px;
        min-width: 200px;
        max-width: 720px;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .btn-back {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: none;
        border: none;
        color: #6b7280;
        font-size: 13px;
        font-weight: 600;
        padding: 0;
        margin-bottom: 4px;
        cursor: pointer;
        width: fit-content;
    }

    .btn-back:hover {
        color: #2563eb;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    [data-bs-theme="dark"] .modern-subtitle {
        color: #9ca3af;
    }

    .header-actions {
        display: flex;
        align-items: center;
        flex: 1 1 320px;
        max-width: 480px;
    }

    .search-box {
        position: relative;
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
    }

    .search-icon {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        pointer-events: none;
        z-index: 1;
    }

    .modern-search-input {
        flex: 1;
        min-width: 0;
        padding: 10px 16px 10px 46px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: #f9fafb;
        color: #1f2937;
    }

    .modern-search-input:focus {
        outline: none;
        border-color: #2563eb;
        background: white;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    [data-bs-theme="dark"] .modern-search-input {
        background: #111827;
        border-color: #374151;
        color: #e5e7eb;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        min-height: 42px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        white-space: nowrap;
    }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
    }

    .modern-btn-primary:hover {
        background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
    }

    @media (max-width: 768px) {
        .modern-header {
            padding: 20px 0;
        }

        .header-content {
            flex-direction: column;
            align-items: flex-start;
        }

        .title-section,
        .header-actions {
            max-width: 100%;
            width: 100%;
        }

        .modern-title {
            font-size: 24px;
        }
    }

    /* Cores usadas pela grade de resultados (var) */
    .pesquisa-periodicos-content {
        --warm-white: #fdfcf9;
        --warm-off: #f5f2eb;
        --gold: #C8922A;
        --gold-light: #E8A83A;
        --gold-pale: #fdf0d5;
        --dark: #1A1A2E;
        --dark-mid: #2a2a42;
        --muted: #7a7060;
        --border: #DEDBD4;
        --border-gold: rgba(200, 146, 42, 0.3);
        --shadow-sm: 0 2px 8px rgba(26, 26, 46, 0.07);
        --shadow-lg: 0 20px 60px rgba(26, 26, 46, 0.14);
        font-family: 'DM Sans', sans-serif;
        background: var(--warm-white);
        color: var(--dark);
        min-height: 100%;
    }

    /* ── MAIN ── */
    main {
        max-width: 1680px;
        margin: 0 auto;
        padding: 2.5rem 3rem 5rem;
    }

    /* ── CABEÇALHO DOS RESULTADOS ── */
    .results-header {
        margin-bottom: 1.75rem;
    }

    .section-label {
        display: flex;
        align-items: center;
        gap: 1rem;

        span {
            font-size: 0.7rem;
            font-weight: 700;
            letter-spacing: 0.14em;
            text-transform: uppercase;
            color: var(--muted);
            white-space: nowrap;
        }

        &::after {
            content: '';
            flex: 1;
            height: 1px;
            background: var(--border);
        }
    }

    /* ── GRID ── */
    .results-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 1.25rem;
    }

    /* ── CARREGAR MAIS ── */
    .load-more {
        display: flex;
        justify-content: center;
        margin-top: 3rem;
    }

    .load-more__btn {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
        background: none;
        border: 1px solid var(--border-gold);
        border-radius: 6px;
        padding: 0.75rem 2rem;
        font-family: 'DM Sans', sans-serif;
        font-size: 0.8rem;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: var(--gold);
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
            background: var(--gold);
            border-color: var(--gold);
            color: #fff;
        }
    }

    /* ── EMPTY STATE ── */
    .empty-state {
        text-align: center;
        padding: 6rem 2rem;
    }

    .empty-icon {
        font-size: 3rem;
        margin-bottom: 1rem;
    }

    .empty-title {
        font-family: 'Playfair Display', serif;
        font-size: 1.25rem;
        font-weight: 700;
        color: var(--dark);
        margin-bottom: 0.5rem;
    }

    .empty-sub {
        font-size: 0.9rem;
        color: var(--muted);
    }

    /* ── RESPONSIVE ── */
    @media (max-width: 1200px) {
        .results-grid {
            grid-template-columns: repeat(3, 1fr);
        }
    }

    @media (max-width: 1000px) {
        main {
            padding-left: 1.25rem;
            padding-right: 1.25rem;
        }

        .results-grid {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (max-width: 575px) {
        .results-grid {
            grid-template-columns: 1fr;
        }
    }
</style>
